export default __webpack_public_path__ + "static/media/singleSummary.8525cefd.svg";